<section class="fund-wallet">
    <div #fundwalletModal id="fundWallet" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" class="modal fade text-left">
        <div role="document" class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header"><strong id="exampleModalLabel" class="modal-title">Fund Wallet</strong>
              <button type="button" data-dismiss="modal" aria-label="Close" class="close"><span aria-hidden="true">×</span></button>
            </div>
            <div class="modal-body">
                <section class="no-padding-top">
                    <div class="container-fluid">
                      <div class="row">
                        <div class="col-lg-12">
                            <div class="block">
                              <div class="title"><strong>Make a Deposit to your Thrively Account</strong></div>
                              <!-- <button type="submit" class="btn btn-secondary">Cancel</button> -->
                              <div class="block-body">
                                <form [formGroup]="FundAccount" (ngSubmit)="fund()"  class="form-horizontal" >
                                 
            
                                  <div class="form-group row">
                                    <label class="col-sm-3 form-control-label">Amount {{ amount | currency:'NGN'}} </label>
                                    <div class="col-sm-9">
                                      <input type="number" 
                                      class="form-control"
                                      formControlName="amount"
                                      id="amount"
                                      name="amount" 
                                      [(ngModel)]="amount"
                                      placeholder="" 
                                      autocomplete="off" 
                                      required>
                                    </div>
                                  </div>
                                  <div class="line"></div>
                                  <div class="form-group row">
                                    <div class="col-sm-9 ml-auto">
                                     <button [disabled]="amount=='' || amount<'200'" 
                                              class="btn btn-primary"
                                     >Fund Pocket</button>
                                    
                                    </div>
                                  </div>

                                  <div class="line"></div>
                                  <div *ngIf="alermsg" class="form-group row">
                                    <label class="col-sm-3 form-control-label" style="color: green; text-transform:uppercase;"> Status {{ paymentResponse.status }} </label>
                                    <div class="col-sm-9">
                                      <p style="color: green; ">{{paymentResponse.message}}</p>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                      </div>
                    </div>
                </section>
           
            </div>
            <div class="modal-footer">
                <p>Powered by Paystack</p>
            </div>
          </div>
        </div>
      </div>
    
      </section>